import React, { FunctionComponent } from 'react';
import { Background } from '../../../types/background';
import { SanityVideo } from '../../../types/common';
import Video from '../../Video';
import './styles.scss';

type VideoCarouselProps = {
  data: {
    background: Background;
    title?: string | null;
    description?: string | null;
    content: [
      {
        video: {
          _id: string;
          video: SanityVideo;
          title: string;
        }
      }
    ];
  };
}

const VideoCarousel: FunctionComponent<VideoCarouselProps> = ({ data }) => {
  return (
    <section className={`video-carousel ${data.background}`}>
      <div>
        {(data.title || data.description) && (
          <div className='content-grid-header'>
            {data.title && (
              <h3>{data.title}</h3>
            )}
            {data.description && (
              <p>{data.description}</p>
            )}
          </div>
        )}
        <div className='video-carousel-container'>
          <div>
            {data.content.map(({ video }) => (
              <div
                key={video._id}
                className='card'
              >
                <Video data={video.video} />
                <p>{video.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default VideoCarousel;
